import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TransferLandingViewModel } from 'shared.root/models/transfer-view-landing.model';

@Component({
  selector: '[nc-transfer-substitute]',
  templateUrl: './transfer-substitute.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})

export class TransferSubstituteComponent {
  @Input() isTransferIn: boolean;
  @Input() item: TransferLandingViewModel;
  @Output() hideAllPopups = new EventEmitter<TransferLandingViewModel>();
  displayCode: string;

  showSubstituted(event: MouseEvent): void {
    event.stopPropagation();
    this.hideAllPopups.emit(this.item);
    this.item.showSubstitutedItem = !this.item?.showSubstitutedItem;
  }

  isTransferInHasSubstitute(): boolean {
    if (this.item && this.item.substitutedItemDetail) {
      this.displayCode = this.item.substitutedItemDetail.altJCode || this.item.substitutedItemDetail.jCode;
    }
    return this.isTransferIn && this.item?.requestedSupplierProductInclusionId > 0;
  }
}
